import React from 'react';
import PropTypes from 'prop-types';
import { Form, Modal, ModalFooter, ModalBody, ModalHeader } from 'reactstrap';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { useParams } from 'react-router-dom';
import { Button, Field, FormAlerts } from '@cordata/buffet';
import usePatient from '~/utils/patient/hook';

import { authorizedInstance as axios } from '~/utils';

const validationSchema = Yup.object().shape({
  note: Yup.string(),
});

const PriorityNote = ({
  data, isModalOpen, setIsModalOpen,
}) => {
  const params = useParams();
  const [,, actions] = usePatient();

  const submitForm = (values, { setErrors, setSubmitting }) => {
    const p = {
      data: {
        id: params.patient_id,
        note: values.note,
      },
    };

    const method = 'put';
    const url = `/patients/${params.patient_id}`;

    axios[method](url, p)
      .then(r => r.data.data)
      .then(() => actions.refresh())
      .catch(e => setErrors({ server: e.errors }))
      .then(() => setSubmitting(false));
  };

  return (
    <Modal
      isOpen={isModalOpen}
      toggle={() => setIsModalOpen(!isModalOpen)}
    >
      <Formik
        displayName="PatientPriorityNote"
        validateOnBlur={false}
        validateOnChange={false}
        initialValues={data}
        validationSchema={validationSchema}
        onSubmit={submitForm}
      >
        {({
          handleSubmit,
          isSubmitting,
          submitCount,
          errors,
        }) => (
          <>
            <ModalHeader>
              {data && data.note ? 'Edit' : 'Add'} Priority Note
            </ModalHeader>
            <Form onSubmit={handleSubmit} noValidate>
              <ModalBody>
                {submitCount >= 1 && errors && <FormAlerts errors={errors} />}

                <Field
                  name="note"
                  type="textarea"
                  label={false}
                />
              </ModalBody>

              <ModalFooter>
                <div className="ml-auto">
                  <Button
                    type="cancel"
                    onClick={() => setIsModalOpen(false)}
                    disabled={isSubmitting}
                  >
                    Cancel
                  </Button>
                  <Button type="submit" disabled={isSubmitting}>
                    {isSubmitting ? 'Working ...' : 'Save'}
                  </Button>
                </div>
              </ModalFooter>
            </Form></>
        )}
      </Formik>
    </Modal>
  );
};

PriorityNote.propTypes = {
  data: PropTypes.shape().isRequired,
  setIsModalOpen: PropTypes.func,
  isModalOpen: PropTypes.bool,
};

PriorityNote.defaultProps = {
  setIsModalOpen: () => {},
  isModalOpen: false,
};

export default PriorityNote;
